import { extractValues } from '../../_util';
import { NEW_NON_EMPLOYEE_KEYS } from '../../_const';
import { NEW_NON_EMPLOYEE_CONFIG } from '../../_config';

/**
 * Cherry-picked configuration for the EpicCare Link User type
 */
const EPICCARE_LINK_CONFIG = {
	[NEW_NON_EMPLOYEE_KEYS.ALTERNATE_EMAIL]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.ALTERNATE_EMAIL],
	},
	[NEW_NON_EMPLOYEE_KEYS.DATE_OF_BIRTH]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.DATE_OF_BIRTH],
	},
	[NEW_NON_EMPLOYEE_KEYS.FIRST_NAME]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.FIRST_NAME],
	},
	[NEW_NON_EMPLOYEE_KEYS.DUPLICATE_ID_CHECK]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.DUPLICATE_ID_CHECK],
	},
	[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_NUMBER]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_NUMBER],
	},
	[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_TYPE]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_TYPE],
	},
	[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_SPECIFIER]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_SPECIFIER],
	},
	[NEW_NON_EMPLOYEE_KEYS.IS_SITE_ADMIN]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.IS_SITE_ADMIN],
	},
	[NEW_NON_EMPLOYEE_KEYS.LAST_NAME]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.LAST_NAME],
	},
	[NEW_NON_EMPLOYEE_KEYS.MIDDLE_INITIAL]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.MIDDLE_INITIAL],
	},
	[NEW_NON_EMPLOYEE_KEYS.NOT_A_DUPLICATE_ACKNOWLEDGEMENT]: {
		...NEW_NON_EMPLOYEE_CONFIG[
			NEW_NON_EMPLOYEE_KEYS.NOT_A_DUPLICATE_ACKNOWLEDGEMENT
		],
	},
	[NEW_NON_EMPLOYEE_KEYS.NOT_A_DUPLICATE_REASON]: {
		...NEW_NON_EMPLOYEE_CONFIG[
			NEW_NON_EMPLOYEE_KEYS.NOT_A_DUPLICATE_REASON
		],
	},
	[NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER],
	},
	[NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER_EXTENSION]: {
		...NEW_NON_EMPLOYEE_CONFIG[
			NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER_EXTENSION
		],
	},
	[NEW_NON_EMPLOYEE_KEYS.PREREQUISITE_CHECK]: {
		...NEW_NON_EMPLOYEE_CONFIG[NEW_NON_EMPLOYEE_KEYS.PREREQUISITE_CHECK],
	},
};

const EPICCARE_LINK_INITIAL_VALUES = extractValues(
	EPICCARE_LINK_CONFIG,
	'initialValue',
	null,
);
const extractedValidationSchema = extractValues(
	EPICCARE_LINK_CONFIG,
	'validationSchema',
	null,
);

/**
 * You can modify the schema in one of the following ways:
 * 1. Extend the schema for a particular field
 * @example
 * //you want to keep the default schema for PHONE_NUMBER, but now you want it required
 *   const EPICCARE_LINK_INITIAL_VALIDATION_SCHEMA = {
        ...extractedValidationSchema,
        [NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER]: extractedValidationSchema[
            NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER
        ].concat(Yup.string().required('Phone Number is required.'))
    };

* 2. Overwrite the schema for a particular field
* @example
* //you want to write an entirely new schema for MIDDLE_INITIAL
* const EPICCARE_LINK_INITIAL_VALIDATION_SCHEMA = {
    ...extractValues(EPICCARE_LINK_CONFIG, 'validationSchema', null),
    [NEW_NON_EMPLOYEE_KEYS.MIDDLE_INITIAL]: Yup.string()
        .trim()
        .matches(
            /^[a-zA-Z]*$/,
            'The value provided contains invalid characters'
        )
        .maxCounter(1)
        .required('Middle Initial is required.'),	//THIS IS NEW
};
*/
const EPICCARE_LINK_INITIAL_VALIDATION_SCHEMA = {
	...extractedValidationSchema,
};

const EPICCARE_LINK_COMPONENTS = extractValues(
	EPICCARE_LINK_CONFIG,
	'component',
	null,
);

const EPICCARE_LINK_USER = {
	name: 'EpicCare Link User',
	id: 90,
};

export {
	EPICCARE_LINK_CONFIG,
	EPICCARE_LINK_INITIAL_VALUES,
	EPICCARE_LINK_INITIAL_VALIDATION_SCHEMA,
	EPICCARE_LINK_COMPONENTS,
	EPICCARE_LINK_USER,
};
